module.exports = __webpack_public_path__ + "static/media/init.820e1f4a.png";